import { render, staticRenderFns } from "./PedidosReport.vue?vue&type=template&id=0a45a3fa&"
import script from "./PedidosReport.vue?vue&type=script&lang=js&"
export * from "./PedidosReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports